
import makerjs from "makerjs";
function B51(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,S1 = Param[2].param,
    // T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       b = B * 1 * myZoom,       
       l = L * 1 * myZoom,       
       s1 = S1 * 1 * myZoom,       
       h = l,
       w = b,
       //hd=r-l,
       hd=Math.sqrt(s1*s1-(b/2*b/2)), hh=h-s1+hd,
       x0 = 0, x1 = 0, x2 = b, x3 = b, y0 = 0, y1 = hh, y2 = hh, y3 = 0,glassH =l, glassW = w;
       if (b !== 0) {
        var TxtB ="B="+ B;
    }  if (l !== 0) {
     var TxtL = "L="+L;
   }    if (s1 !== 0) {
    var TxtS1 = "S1="+S1;
  }
   var drawAbnormalShapeB51 = {
       paths: {
        
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "ArcLine": new makerjs.paths.Arc([x1,y1], [x2,y2], s1, false, true),
        "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
        "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeB51MarkB = {
       paths: {
        "bottomLine": new makerjs.paths.Line([0, -markShift], [b, -markShift]),        
        "RightShortUpline": new makerjs.paths.Line([0, 0], [0, -3*markShift]),
        "RightShortDnline": new makerjs.paths.Line([b, 0], [b, -3*markShift]),
       }  
   };
   var drawAbnormalShapeB51MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x1- markShift, y0+h]),
        "RightShortUpline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
        "RightShortDnline": new makerjs.paths.Line([x1, y0+h], [x1- 2 * markShift, y0+h]),
       }
   };
   var drawAbnormalShapeB51MarkS1 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([b/2, h], [b/2, h-s1]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeB51MarkB, TxtB,  [0,-2*markShift], [b, -2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB51MarkL, TxtL,  [x0- 2*markShift, y0], [x1- 2*markShift, y2]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB51MarkS1, TxtS1, [b/2, h-s1-markShift], [b/2+2*markShift, h-s1-markShift]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB51: drawAbnormalShapeB51,
      }
    };
  markers={
      models: {
        drawAbnormalShapeB51: drawAbnormalShapeB51,
        drawAbnormalShapeB51MarkB:drawAbnormalShapeB51MarkB,
        drawAbnormalShapeB51MarkL:drawAbnormalShapeB51MarkL,
        drawAbnormalShapeB51MarkS1:drawAbnormalShapeB51MarkS1,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B51;